/**
 * SpeecargoTheme - Component Customizations
 * Ant Design component-level theme overrides
 */

import type { ThemeConfig } from 'antd';

/**
 * Dark Theme Component Customizations
 */
export const DARK_COMPONENTS: ThemeConfig['components'] = {
	Button: {
		// Primary button style
		colorPrimary: '#475359',
		colorTextLightSolid: '#ffffff',
		primaryShadow: '0 4px 8px rgba(0,0,0,0.3)',
		colorPrimaryHover: '#5c6a75',
		colorPrimaryActive: '#3b454d',

		// Default button style
		colorBgContainer: '#484C50',
		colorBorder: '#5a5f63',
		colorText: '#ffffff',
		defaultHoverBg: '#5a5f63',
		defaultHoverColor: '#ffffff',
		defaultActiveBg: '#3c3f42',
	},
	Modal: {
		contentBg: '#232323',
		headerBg: '#232323',
		titleColor: '#ffffff',
		colorText: '#ffffff',
	},
	Input: {
		colorBgContainer: '#484C50',
		colorText: '#ffffff',
		colorBorder: '#484C50',
		activeShadow: '0 0 0 2px rgba(71,83,89,0.4)',
		colorTextPlaceholder: '#bfbfbf',
		hoverBorderColor: '#333333',
		activeBorderColor: '#333333',
	},
	Select: {
		hoverBorderColor: '#333333',
		activeBorderColor: '#333333',
	},
	DatePicker: {
		hoverBorderColor: '#333333',
		activeBorderColor: '#333333',
	},
	Form: {
		labelColor: '#ffffff',
		colorText: '#ffffff',
	},
	Table: {
		colorBgContainer: '#0a0c0d',
		headerColor: '#ffffff',
	},
	Card: {
		colorBgContainer: '#232323',
	},
	Checkbox: {
		colorPrimary: '#808080',
		colorPrimaryHover: '#696969',
		borderRadius: 4,
		colorWhite: '#000000',
	},
};

/**
 * Light Theme Component Customizations
 * Currently minimal, can be extended as needed
 */
export const LIGHT_COMPONENTS: ThemeConfig['components'] = {
	// Add light theme component customizations here if needed
	// Currently using Ant Design's default light theme
};
